export default{"Login Successful":"Login Successful","Check Password":"Check Password","Unknown Error":"Unknown Error"};
